import { MAX_LENGTH, PHONE_REGEX } from './validationTypes'
import { FormData } from './types'

export const validateField = (
    field: keyof FormData,
    value: string | boolean,
    formData: FormData
): string | null => {

    if (!['lastName', 'firstName', 'age', 'email', 'phone'].includes(field as string)) {
        return null
    }

    switch (field) {
        case 'lastName':
            if (!value) return '姓は必須です'
            if (typeof value === 'string' && value.length > MAX_LENGTH) return `姓は${MAX_LENGTH}文字以内で入力してください`
            break

        case 'firstName':
            if (!value) return '名は必須です'
            if (typeof value === 'string' && value.length > MAX_LENGTH) return `名は${MAX_LENGTH}文字以内で入力してください`
            break

        case 'phone':
            if (!value) return '電話番号は必須です'
            if (typeof value === 'string') {
                if (!/^\d{11}$/.test(value)) return '電話番号は11桁の数字で入力してください'
                if (!PHONE_REGEX.test(value)) return '060、070、080、090から始まる形で入力してください'
            }
            break

        case 'age':
            if (!value) return '年齢は必須です'
            if (typeof value === 'string') {
                if (!/^\d+$/.test(value)) return '年齢は数値で入力してください'
                const ageNum = parseInt(value, 10)
                if (ageNum <= 0 || ageNum >= 100) return '年齢は1〜99の間で入力してください'
            }
            break

        case 'email':
            if (!value) return 'メールアドレスは必須です'
            if (typeof value === 'string') {
                // バックエンドの EmailValidation::VALID_EMAIL_REGEX と同じ基準に統一。TLDなしのアドレスを弾くため。
                const emailRegex = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i
                if (!emailRegex.test(value)) return '有効なメールアドレスを入力してください'
            }
            break
    }

    return null
}

export const isStepValid = (step: number, formData: FormData): boolean => {
    switch (step) {
        case 3:
            return !!formData.lastName &&
                !!formData.firstName &&
                !!formData.age &&
                !validateField('lastName', formData.lastName, formData) &&
                !validateField('firstName', formData.firstName, formData) &&
                !validateField('age', formData.age, formData)

        case 4:
            return !!formData.phone &&
                !!formData.email &&
                !validateField('phone', formData.phone, formData) &&
                !validateField('email', formData.email, formData)

        default:
            return true
    }
}

export const isFormValid = (formData: FormData): boolean => {
    return !!formData.lastName &&
        !!formData.firstName &&
        !!formData.age &&
        !!formData.email &&
        !!formData.phone &&
        !validateField('lastName', formData.lastName, formData) &&
        !validateField('firstName', formData.firstName, formData) &&
        !validateField('age', formData.age, formData) &&
        !validateField('email', formData.email, formData) &&
        !validateField('phone', formData.phone, formData)
}
